// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"247e6849","198":"a777a7e1","355":"ecad953b"}[chunkId] + ".chunk.js";
};